<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/28/20
-->

<template>
	<!--	<div class="fill-height-container">-->
	<!--		<LoadingIndicator-->
	<!--			v-if="isProgressShowing"-->
	<!--			:message="progressText"-->
	<!--			class="center-absolute"/>-->
	<!--		<div class="fill-height-container">-->
	<!--			<div v-if="valueData.length === 0" class="row align-items-center justify-content-center fill-height-container">-->

	<!--			</div>-->

	<!--			<div class="fill-height-container">-->
	<!--				<div><hr class="my-0"/></div>-->
	<PagerTable
		ref="table"
		:dataArray="valueData"
		:scrollContainerSelector="scrollContainerSelector"
		:hideEmptyViewFilter="hideEmptyViewFilter"
		:addBottomMargin="addBottomMargin"
		:hasFilterApplied="hasFilterApplied"
		:dataPager="getDataPager"
		v-bind="$attrs"

		:analytics-props="analyticsPropsMethod()">
		<template #header>
			<slot name="header"></slot>
		</template>
		<template #items-container="{dataArray}">
			<slot name="items-container" :dataArray="dataArray"></slot>
		</template>
		<template #item="{item, index}">
			<slot name="item" :item="item" :index="index" v-bind="$attrs">
				<div class="px-2 py-3 qw-row show-on-hover-parent"
					 :class="[{'clickable-item': isClickableItems}, itemClasses]"
					 @click="$emit('onItemClicked', item)">
					<div class="col px-0">
						<slot name="item-title" :item="item" :index="index">
							{{ item.title || item.name || "Item" }}
						</slot>
					</div>
					<slot name="item-postfix" :item="item" :index="index"></slot>
					<!--									<div class="layout-spacer"></div>-->
					<!--					:class="{'show-on-hover-item': !forceShowMenu(index)}"-->
					<div v-if="!hideMenuItems && menuItems != null"
						 class="text-right"
						 :style="{'min-width': menuMinWidth}"
					>
						<div class="display-inline-block">

						<OptionsMenu menu-icon="icon-ellipsis-vert"
									 :menu-items="getMenuItems(item)"
									 @onMenuVisibilityChanged="(isVisible) => onMenuVisibilityChanged(isVisible, index)"
									 @click="menuItem => $emit('menuItemClicked', menuItem, item)"/>
						</div>

					</div>
				</div>
				<hr v-if="showDivider" class="my-0"/>

			</slot>
		</template>
		<template #empty-view>
			<slot name="empty-view">
				<div class="text-center">
					No items to display.
				</div>
			</slot>
		</template>

		<template #empty-view-filter>
			<slot name="empty-view-filter">
				<qw-empty>
					<template #title>
						<slot name="empty-view-filter-title">
							No items to display
						</slot>
					</template>
					<template #sub-title>
						<slot name="empty-view-filter-sub-title">
							Try adjusting your search criteria
						</slot>
					</template>
				</qw-empty>
			</slot>

		</template>


	</PagerTable>
	<!--			</div>-->


	<!--		</div>-->
	<!--	</div>-->
</template>

<script>
import BasePagerView from "@/core/components/Data/BasePagerView.vue";
import PagerTable from "@/core/components/Data/PagerTable.vue";
import OptionsMenu from "@/core/components/Menu/OptionsMenu.vue";
import BaseIdObject from "@shared/BaseIdObject.js";

export default {
	name: "PagerListLayout",
	components: {OptionsMenu, PagerTable},
	extends: BasePagerView,
	props: {
		scrollContainerSelector: String,
		addBottomMargin: Boolean,
		pagerProvider: {type: Function, required: true},
		emptyMessage: {type: String, default: "No items to display"},
		menuItems: [Array, Function],
		hideMenuItems: Boolean,
		showDivider: {Boolean, default: true},
		hideEmptyViewFilter: [Boolean, Function],
		modelValue: null,
		isClickableItems: {Boolean, default: true},
		itemClasses: String,
		hasFilterApplied: Function,
		menuMinWidth: {String, default: "20px"},
	},
	watch: {
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				this.valueData = this.formatDataIn(newVal || [])
				console.log("PagerListLayout: value = ", newVal, ", this.valueData = ", this.valueData)
			},
		},
	},
	data() {
		return {
			valueData: null,
			dataPager: null,
			menuVisibleIndex: -1,
			menuItemsCache: []
		}
	},
	mounted() {
		// this.loadData()
	},

	methods: {


		// async onDataChanged(newData, isInitialLoad) {
		// 	this.notifyValueChanged()
		// },

		// getTableView() {
		// 	console.log("getTableView: this.$refs.table = " + this.$refs.table)
		// 	return this.$refs.table
		// },
		//
		// getDataField() {
		// 	return this.valueData
		// },

		async dataPagerProvider() {
			//TODO fix caching - caching breaks ClientPickerView for example as it requires changing interface for existing code
			// if(!this.dataPager){
			this.dataPager = await this.pagerProvider()
			// }
			this.dataPager.reset()
			return this.dataPager
		},

		getObjectHashForMenu(item){
			return item.id ? item.id : item
		},

		menuInvalidateCache(item){
			let objectHash = this.getObjectHashForMenu(item)
			// this.$set(this.menuItemsCache, objectHash, null)
			this.menuItemsCache[objectHash] = null
		},

		getMenuItems(item) {
			let menuItems
			if (typeof this.menuItems === "function") {
				let objectHash = this.getObjectHashForMenu(item)
				// console.log("PagerListLayout.getMenuItems: objectHash = ", objectHash)
				if (!this.menuItemsCache[objectHash]) {
					console.log("PagerListLayout.getMenuItems: this.menuItems(item) = ", this.menuItems(item))
					menuItems = this.menuItems(item).filter(item => !!item) //filter out any null/empty menu items
					// this.$set(this.menuItemsCache, objectHash, menuItems)
					this.menuItemsCache[objectHash] = menuItems
				}
				menuItems = this.menuItemsCache[objectHash]
				// console.log("PagerListLayout.getMenuItems: this.menuItemsCache = ", this.menuItemsCache)
			} else {
				menuItems = this.menuItems
			}
			// console.log("PagerListLayout.getMenuItems: = ", menuItems)

			return menuItems
		},

		getElementSearchPredicate(element) {
			let isDbObject = element instanceof BaseIdObject
			return isDbObject ? t => t.id === element.id : t => t === element
		},

		notifyElementDeleted(elements) {
			if(!Array.isArray(elements)){
				elements = [elements]
			}
			for(let element of elements) {
				let predicate = this.getElementSearchPredicate(element)
				let index = this.valueData.findIndex(predicate)
				this.valueData.splice(index, 1)
			}
		},
		notifyElementUpdated(elements) {
			if(!Array.isArray(elements)){
				elements = [elements]
			}
			for(let element of elements){
				this.menuInvalidateCache(element)
				let predicate = this.getElementSearchPredicate(element)
				let index = this.valueData.findIndex(predicate)
				this.valueData.splice(index, 1, element)
				console.log("notifyElementUpdated: index = ", index, ", element = ", element, ", this.valueData = ", this.valueData, ", predicate = ", predicate)
			}

		},
		notifyElementAdded(elements) {
			if(!Array.isArray(elements)){
				elements = [elements]
			}
			elements = elements.filter(elem => !this.valueData.find(this.getElementSearchPredicate(elem)))
			this.valueData.unshift(...elements)
		},


		formatDataIn(data) {
			return data
		},

		formatDataOut(data) {
			return data
		},

		onMenuVisibilityChanged(isVisible, index) {
			this.menuVisibleIndex = isVisible ? index : -1
		},

		forceShowMenu(index) {
			return this.menuVisibleIndex === index
		},


		notifyValueChanged() {
			let data = this.formatDataOut(this.valueData)
			// console.log("notifyValueChanged: this.valueData = ", data)

			this.$emit('update:modelValue', data)
			this.$emit('change', data)
		},

	},


}
</script>

<style>

</style>
